// extracted by mini-css-extract-plugin
export var checklist = "checklist-module--checklist--6PTrJ";
export var purposeDetox = "checklist-module--purposeDetox--1cQ0d";
export var subHeading = "checklist-module--subHeading--ZK5KI";
export var row = "checklist-module--row--3Z1aE";
export var item = "checklist-module--item--1LoD2";
export var icon = "checklist-module--icon--16NiE";